import { companyApi } from 'store/api/company';

import { supportRequests } from './requests';
import {
  SupportLog,
  CareReceipt,
  SupportReport,
  ReceiptSupport,
  SupportLogRequest,
  SupportReportRequest,
} from './types';

export * from './types';
export { isNotLinked, NOT_FOUND_OK, supportRequests } from './requests';

// Customer care (Support ⇄ POS, Phase 2): what POS shows about refunds and
// replacements done from the Support app. Read-only; served by Ops under
// /api/v1/support/pos (the receipt strips for any signed-in user of the
// company, the log and the report for the customer_support feature).
const supportApi = companyApi.injectEndpoints({
  endpoints: (build) => ({
    // Customer care's read-only receipt (feature customer_support): "Open in
    // POS" from Support and the log rows land on it; no Checkout needed.
    careReceipt: build.query<CareReceipt, number>({
      query: supportRequests.careReceipt,
    }),
    supportLog: build.query<SupportLog, SupportLogRequest>({
      query: supportRequests.supportLog,
    }),
    receiptSupport: build.query<ReceiptSupport, number>({
      query: supportRequests.receiptSupport,
    }),
    supportReport: build.query<SupportReport, SupportReportRequest>({
      query: supportRequests.supportReport,
    }),
  }),
});

export const {
  useSupportLogQuery,
  useCareReceiptQuery,
  useSupportReportQuery,
  useReceiptSupportQuery,
  useLazySupportLogQuery,
} = supportApi;
